import DropDownComponent from "./DropDown";

const WeekDropdown = ({ selectedValue, onchange, isError, error, dropdownLabel = "Day", readOnly = false }) => {
  const dayArr = [
    { id: 0, name: "0" },
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" }
  ];

  return (
    <DropDownComponent fixedWidth="100%"
      isShowZero={false}
      isError={isError}
      error={error}
      readOnly={readOnly}
      selectedValue={selectedValue}
      name="day"
      initialValue=""
      list={dayArr}
      dropdownLabel={dropdownLabel}
      onchange={onchange}
    />
  );
};

export default WeekDropdown;
